import comp from "./TagSnpModalV4";
export default comp;
